import { Component, Input, OnInit } from '@angular/core';

import { IonNav, ModalController } from '@ionic/angular';

import { AssetInformationContentModalPage } from '../asset-information-content-modal/asset-information-content-modal.page';

import { ApiService } from '@services/api.service';

import { IAsset, IAssetInformation } from '@models/types';

import * as dayjs from 'dayjs';

@Component({
    selector: 'app-asset-type-selection-modal',
    templateUrl: './asset-type-selection-modal.page.html',
    styleUrls: ['./asset-type-selection-modal.page.scss'],
})
export class AssetTypeSelectionModalPage implements OnInit {
    @Input() public state: Partial<IAssetInformation> = this.nav.rootParams.state;

    public dayjs = dayjs;

    public latestAssetFormConfigIds: string[] = [];
    public isDataLoaded = false;

    constructor(
        private apiService: ApiService,
        private modalController: ModalController,
        private nav: IonNav
    ) { }

    async ngOnInit() {
        const latestAssetFormConfigIds: string[] = [];
        for await (const asset of (this.state.assets as IAsset[])) {
            const { id } = await this.apiService.getLatestAssetFormConfig(asset.asset_form_config_id);
            latestAssetFormConfigIds.push(id);
        }
        this.latestAssetFormConfigIds = latestAssetFormConfigIds;
        this.isDataLoaded = true;
    }

    public async viewAsset(assetId: string, latestAssetFormConfigId: string) {
        try {
            const asset: IAsset = await this.apiService.getAsset(assetId);
            const state: Partial<IAssetInformation> = {
                asset,
                assetId: assetId,
                latestAssetFormConfigId: latestAssetFormConfigId,
                multi: false,
                type: 'view',
                pageType: 'modal',
                canGoBack: true
            }
            this.nav.push(AssetInformationContentModalPage, { state });
        } catch (error) {
            console.log('AssetTypeSelectionModalPage viewAsset() error=', error);
        }
    }

    public async selectAsset(assetId: string) {
        await this.modalController.dismiss(assetId);
    }

    public async closeModal() {
        await this.modalController.dismiss();
    }

}
